import type { SVGProps } from 'react';

const ProductionOrdersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='20'
    viewBox='0 0 18 20'
    fill='none'
    {...props}>
    <path d='M6 5V7H12V5H6Z' fill='currentColor' />
    <path d='M13 5H15V7H13V5Z' fill='currentColor' />
    <path d='M6 8V10H12V8H6Z' fill='currentColor' />
    <path d='M13 8H15V10H13V8Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H0V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM3 18C2.45 18 2 17.55 2 17V16H12V18H3ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V14H5V3H16V17Z'
      fill='currentColor'
    />
  </svg>
);

export default ProductionOrdersIcon;
